import { Box, Text } from "@chakra-ui/react";
import * as React from "react";

import { useTracking } from "contexts/Tracking";
import { useDetailState } from "scenes/OfferDetail";
import { IMarginProps } from "src/types/types";
import InfoBanner from "./InfoBanner";
import Button from "components/Chakra/Button";
import { useWatchdogOfferModal } from "modals/useWatchdogOfferModal";
import IconDog from "components/Chakra/Icons/Dog";

const WatchdogBanner: React.FC<IMarginProps> = ({ ...margins }) => {
  const { trackEvent } = useTracking();
  const { openModal: openWatchdogOfferModal } = useWatchdogOfferModal();

  const { offer } = useDetailState();

  if (!offer) {
    return null;
  }

  return (
    <Box {...margins}>
      <InfoBanner
        icon={
          <IconDog
            fillWith="ud-primary"
            data-test="offerDetail.watchdogBanner.icon"
          />
        }
      >
        <Box>
          <Text variant="small_2" data-test="offerDetail.watchdogBanner.text">
            Hlídací pes najde podobné bydlení za vás.
          </Text>
          <Button
            onClick={() => {
              trackEvent({
                "dl.eCat": "offer_detail",
                "dl.eAct": "watchdog.clicked",
                "dl.eLab": "Hlídaní podobných",
              });
              openWatchdogOfferModal({
                offer,
                loginEvent: {
                  LOGIN: {
                    "dl.eAct": "login",
                    "dl.eLab": "Premium - Hlídací pes",
                    "dl.eCat": "",
                  },
                  REGISTRATION: {
                    "dl.eAct": "registration",
                    "dl.eLab": "Premium - Hlídací pes",
                    "dl.eCat": "offer_detail",
                  },
                },
              });
            }}
            textDecor="underline"
            data-test="offerDetail.watchdogBanner.createDoggo"
            variant="link"
            size="sm"
          >
            Vytvořit Hlídacího psa
          </Button>
        </Box>
      </InfoBanner>
    </Box>
  );
};

export default WatchdogBanner;
